import endPoints from './endPoints'
import axios from '../../../../../../../services/axios'

const { show } = endPoints

export const getShowByMobile = async (mobile) => (
	await axios.get(`${show}${mobile}`)
)
